import React from 'react';
import { string } from 'prop-types';

import * as helpers from './helpers';

const ContactsIcon = ({ color, ...props }) => (
  <svg {...helpers.getSvgDimensionsProps(props)} fill={color} {...props}>
    <path
      d="M15.3667 3.51668C15.325 3.41668 15.275 3.32501 15.2167 3.23334C15.1 3.05834 14.9417 2.90001 14.7667 2.78334C14.675 2.72501 14.5833 2.67501 14.4833 2.63334C14.2833 2.55001 14.0667 2.50001 13.8333 2.50001H13V0.833344H11.3333V2.50001H4.66667V0.833344H3V2.50001H2.16667C1.81667 2.50001 1.5 2.60834 1.23333 2.78334C1.05833 2.90001 0.9 3.05834 0.783333 3.23334C0.725 3.32501 0.675 3.41668 0.633333 3.51668C0.55 3.71668 0.5 3.93334 0.5 4.16668V15.8333C0.5 16.75 1.24167 17.5 2.16667 17.5H13.8333C14.0667 17.5 14.2833 17.45 14.4833 17.3667C14.5833 17.325 14.675 17.275 14.7667 17.2167C14.9417 17.1 15.1 16.9417 15.2167 16.7667C15.3917 16.5 15.5 16.175 15.5 15.8333V4.16668C15.5 3.93334 15.45 3.71668 15.3667 3.51668ZM2.16667 15.8333V4.16668H13.8333V15.8333H2.16667ZM8 10.7333C6.30833 10.7333 3 11.6333 3 13.7167V15H13V13.725C13 11.6333 9.69167 10.7333 8 10.7333ZM4.925 13.3333C5.5 12.8667 6.90833 12.4 8 12.4C9.09167 12.4 10.5083 12.8667 11.075 13.3333H4.925ZM8 10C9.375 10 10.5 8.87501 10.5 7.50001C10.5 6.12501 9.375 5.00001 8 5.00001C6.625 5.00001 5.5 6.12501 5.5 7.50001C5.5 8.87501 6.625 10 8 10ZM8 6.66668C8.45833 6.66668 8.83333 7.04168 8.83333 7.50001C8.83333 7.95834 8.45833 8.33334 8 8.33334C7.54167 8.33334 7.16667 7.95834 7.16667 7.50001C7.16667 7.04168 7.54167 6.66668 8 6.66668Z"
    />
  </svg>
);

ContactsIcon.propTypes = {
  color: string.isRequired,
  ...helpers.iconDimensionsPropTypes,
};

ContactsIcon.defaultProps = {
  ...helpers.getDefaultIconDimensionsProps(16, 18),
};

export default ContactsIcon;



// WEBPACK FOOTER //
// ./src/components/svg-icon/icons/contacts.js